/*eslint-disable */
import React, { useState } from "react";

// Custom Components
import Table from "@Components/Table";
import withSelect from "../withSelect";
import Filter from "components/Filter";
import { URLS } from "configs/constants";

let model = [
  { id: "name", label: "Name", type: "string" },
  { id: "state_name", label: "State", type: "string" },
];

const actions = ["edit"];

const filterInitialValues = {
  name: "",
};

const DistrictList = () => {
  const [filterValues, setFilterValues] = useState({});
  const filterFields = [
    {
      type: "input",
      label: "Name",
      name: "name",
    },
  ];

  const onFilterRequest = (values) => {
    let filterObj = {};
    for (const [key, value] of Object.entries(values)) {
      if (value !== null && value !== "") {
        filterObj[key] = value;
      }
    }
    setFilterValues(filterObj);
  };

  return (
    <div>
      {/* FIXME: 10953 - Filter hidden for now */}
      <Filter
        initialValues={filterInitialValues}
        filterFields={filterFields}
        onSubmit={onFilterRequest}
      />
      <Table
        proxyURL="location/district/"
        model={model}
        actions={actions}
        filterValues={filterValues}
        noFilter
      />
    </div>
  );
};

export default withSelect(DistrictList, URLS.DISTRICT_CUSTOM_FIELDS);
